import { withPaymentsClient } from 'payments-checkout-lib/data/clients';
// @ts-ignore Untyped module
import { catchAndRethrowNetworkError } from 'crm_data/bCommerce/monitoring/errorUtils';
export const fetchCountryMetadata = withPaymentsClient((client, {
  countryCode
}) => {
  return client.get(`payments-checkout/v1/checkout-sessions/address-metadata/${countryCode}`).catch(catchAndRethrowNetworkError);
});